import { Quote } from "lucide-react";

interface SignalCitationPanelProps {
  text: string;
}

const formatCitation = (citation: string): string => {
  const trimmed = citation.trim();
  if (!trimmed) {
    return trimmed;
  }

  const hasQuotes =
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"));

  return hasQuotes ? trimmed : `"${trimmed}"`;
};

const SignalCitationPanel = ({ text }: SignalCitationPanelProps) => (
  <div className="rounded-lg bg-blue-50 px-4 py-3">
    <div className="mb-2 flex items-center gap-2">
      <Quote className="h-4 w-4 shrink-0 text-blue-600" />
      <p className="text-sm font-semibold text-blue-700">Citation</p>
    </div>
    <p className="text-sm leading-5 text-blue-700">{formatCitation(text)}</p>
  </div>
);

export default SignalCitationPanel;
